import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import moment from "moment";
import { BU_STORE_HEADER } from "store/auth/login/actionTypes";

export const errorMessage = error => {
  const message =
    error.response && error.response.data
      ? error.response.data
      : { message: error.message };
  return { ...message };
};

export const formatTaxCode = value => {
  let finalValue = value;
  if (value.length === 13) {
    const char = "-";
    const position = 10;
    finalValue = [
      finalValue.slice(0, position),
      char,
      finalValue.slice(position),
    ].join("");
  }
  return finalValue;
};

export const base64toBlob = data => {
  if (Object.keys(data).length > 0) {
    const base64WithoutPrefix = data.substr(
      "data:application/pdf;base64,".length
    );
    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: "application/pdf" });
  }
};

export const convertDate = (data, format = "") => {
  const type = typeof data;
  let date = null;
  if (type === "object") {
    if (format === "date") {
      let dateSet = new Date(data);
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        dateSet
      );
      let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        dateSet
      );
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        dateSet
      );

      date = `${ye}-${mo}-${da}`;
    } else if (format === "label") {
      let dateSet = new Date(data);
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        dateSet
      );
      let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        dateSet
      );
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        dateSet
      );

      date = `${da}/${mo}/${ye}`;
    } else {
      date = Math.round(new Date(data).getTime() / 1000);
    }
  } else {
    date = data;
  }
  return date;
};

export const convertToDD_MM_YYY = (input, symbol = "/") => {
  const datePart = input.match(/\d+/g),
    year = datePart[0], // get only two digits
    month = datePart[1],
    day = datePart[2];

  return day + symbol + month + symbol + year;
};

export const numberWithCommas = (x, isShow) => {
  if (x) {
    let dau = "";
    if (isShow) {
      dau = x > 0 ? "+" : "";
    }
    return dau + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return "";
};

export const downloadToolUsbToken = () => {
  const link = document.createElement("a");
  link.href = `https://inv.4si.vn/tools/4si_signer_windows.zip`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const toastWarningIsAllStore = addToast => {
  const buStoreHeader = localStorage.getItem(BU_STORE_HEADER);
  if (buStoreHeader === ALL_STORE || buStoreHeader === ALL_BU) {
    addToast("Vui lòng chọn chi nhánh/ đơn vị cụ thể cần thao tác", {
      appearance: "error",
      autoDismiss: true,
    });
    return true;
  }
  return false;
};

export const getFileNameExcel = fileName => {
  const date = moment(new Date()).format("DD_MM_YYYY");
  return fileName + "_" + date + ".xlsx";
};

export const toastNoRowSelect = (addToast, t) => {
  addToast("Vui lòng chọn dòng cần thao tác", {
    appearance: "warning",
    autoDismiss: true,
  });
};
